import axios from "axios";
import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const OrganizationService = {
  getList: async ({ pageNumber, pageSize, statusFilter = "all", searchQuery = "" }) => {
    try {
      let url = `/${slug}/organization?pageNumber=${pageNumber}&pageSize=${pageSize}`;
      
      // Add isPaid filter if status is not 'all'
      if (statusFilter !== "all") {
        url += `&isPaid=${statusFilter === "paid"}`;
      }

      // Add OrgName filter if searchQuery exists
      if (searchQuery.trim()) {
        url += `&OrgName=${encodeURIComponent(searchQuery)}`;
      }

      const response = await apiService.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getOrgList: async ({ pageNumber, pageSize }) => {
    try {
      const url = `/${slug}/organization?pageNumber=${pageNumber}&pageSize=${pageSize}`;
      const response = await apiService.get(url); 
      return response.data; 
    } catch (error) {
      throw error;
    }
  },
  
  create: async ({ data }) => {
    const response = await apiService.post(`/${slug}/organization`, data);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/organization/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/organization/${id}`);
    return response.data;
  },

  // In OrganizationService.js
  setAsPaid: async (data) => {
    try {
      const response = await axios.post(`/${slug}/organization/setaspaid`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },


  setAsHasOMS: async (data) => {
    try {
      const response = await axios.post(`/${slug}/organization/setashasoms`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  setHasSalesScreen: async (data) => {
    try {
      const response = await axios.post(`/${slug}/organization/sethassalesscreen`, data,{
        headers:{
          "Content-Type":"application/json",
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },

   createOrgDatabase: async ({data}) => {
    console.log(data)
    try {
      const response = await apiService.post(`/${slug}/organization/settenantinfo`, data);
      console.log(response)
      return response.data;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },

    updateOrgDatabase: async ({data, id}) => {
    console.log(data)
    console.log(id)
    try {
      const response = await apiService.put(`/${slug}/tenant/${id}`, data);
      console.log(response)
      return response.data;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },

  GetOrgDatabaseList: async () => {
    // console.log(data)
    try {
      const response = await apiService.get(`/${slug}/tenant`);
      console.log(response)
      return response;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },

   GetOrgDatabaseDetail: async (id) => {
    // console.log(data)
    try {
      const response = await apiService.get(`/${slug}/tenant/${id}`);
      console.log(response)
      return response;
    } catch (error) {
      console.error("Error updating sales screen:", error);
      throw error;
    }
  },


};

export default OrganizationService;
